/** Метка относится к конкретному объекту SWR и URL, не к ещё одной копии данных.
 * WeakMap не удерживает массивы после удаления из SWR. Optimistic update,
 * заменивший объект, автоматически теряет метку и требует обычного GET.
 */
const versions = new WeakMap<object, { url: string; etag: string }>();

export function rememberResponseVersion(data: unknown, url: string, etag: string | null): void {
  if (etag && data !== null && typeof data === "object") versions.set(data, { url, etag });
}

export function responseVersion(data: unknown, url: string): string | undefined {
  if (data === null || typeof data !== "object") return undefined;
  const version = versions.get(data);
  return version?.url === url ? version.etag : undefined;
}
